import React, { Component } from "react";
import {
  Button,
  Space,
  Col,
  message,
  Form,
  Input,
  Row,
  Select,
  Upload,
  Modal,
  Tooltip,
  Spin,
  Checkbox,
} from "antd";
import "./Form.css";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";

import CreditStore from "../store/CreditStore";
import CompanyAutocomplete from "./CompanyAutocomplete";


import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import conf from "../config";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";

const layout = {
  labelCol: { span: 23 },
  wrapperCol: { span: 30 },
};
const { Option } = Select;
class CreditAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      companyId: "",
      loadList: 0,
      offset: "",
      limit: "",
      searchField: "",
      creditType: "",
      getRolesList: [],
      departmentId: "",
      userId: -1,
      fileList: [],
      showDeptForm: false,
      loading: false,
      isadmin: 0,
      userType: 1,
      loadingSpin: false,
      disabledField: false,

      submitAction: null
    };
    
    this.creditStore = new CreditStore();
    
    // this.selectDepartment = this.selectDepartment.bind(this);
    this.cookies = new Cookies();
    this.handleChange = this.handleChange.bind(this);
    this.selectCreditType = this.selectCreditType.bind(this);
 
  }
  async handleChange(comp) {
     await this.setState({ companyId: comp.value });
     this.context.viewStateStore.setCreditStates({
        companyId: comp.value,
         creditType: this.state.creditType,
      });

      //console.log(this.context.viewStateStore.creditStatesObj);
   
  }

   async selectCreditType(value, option) {
      await this.setState({creditType:value})
       this.context.viewStateStore.setCreditStates({
        creditType: value,
        companyId:this.state.companyId
      });
     // console.log(this.context.viewStateStore.creditStates.creditType);
    }
 

  onCreditSubmit = async (fieldsValue) => {
    console.log(fieldsValue)
    console.log(this.state.submitAction)
   
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      createdUserId: this.props.getUserData().userId,
      createdCompanyId: this.props.getUserData().userCompanyId,
      submitAction: this.state.submitAction
      
    };
    console.log(data);
    const resp = await this.creditStore.addData(data);

    await this.props.response(resp);

    this.setState({ loading: false });
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      // await this.setState({userId:this.props.getUserData().userId})
      await this.setState({ isadmin: this.props.getUserData().isadmin });
    }
   
  }
  
  closeModal = () => {
    this.props.closeModal();
  };
  handleButtonClick = (action) => {
    this.setState({ submitAction: action });
  };
  render() {
    return (
      <div style={{ padding: 0 }}>
        <div style={{ paddingBottom: "10px" }}>
          {/* change style */}
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              {...layout}
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onCreditSubmit}
              className="formClass" //change
            >
              <Row className="overflowFormInputs">
                {/* css class */}
                <Col span={12} className="formColumnClass">
                  {/* css class */}

                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      label={this.context.translate("_ACCOUNT_")}
                      rules={[{ required: true,message: this.context.translate("_PLEASE_SELECT_ACCOUNT_") }]}
                      // style={this.context.isAdmin===1? {display:'none'}:''}
                    >
                      <CompanyAutocomplete
                        onChange={this.handleChange}
                        style={{ width: "100%" }}
                        companyId={this.state.companyId}
                        distributorOnly = {true}
                      />
                    </Form.Item>
                  )}
                
                  


                  <Form.Item
                    name="creditAdded"
                    label={this.context.translate("_NO_OF_CREDITS_")}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  


                
                </Col>

                <Col span={12} className="formColumnClass">
                 <Form.Item
                      name="creditType"
                      label={this.context.translate(
                        "_CREDIT_TYPE_"
                      )}
                      rules={[{ required: true,message: this.context.translate("_PLEASE_SELECT_CREDITTYPE_") }]}
                    >
                      <Select
                        placeholder={this.context.translate(
                                  "_SELECT_CREDIT_TYPE_"
                                )}
                        onChange={async (val, option) => {
                            await this.selectCreditType(val, option);
                        }}        
                      >
                       
                        <Select.Option value="New">
                          {this.context.translate("_NEW_")}
                        </Select.Option>
                        <Select.Option value="Renew">
                          {this.context.translate("_RENEW_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                
                  
                 

                  

                  
                </Col>
              </Row>

              <div className="formBtnGroup">
                {/* css class */}
                <Space>
                <Button
                  //className="formCancelButton"
                  onClick={(e) => {
                    this.closeModal();
                    // this.formRef.current?.resetFields();
                  }}
                >
                  {/* css class */}
                  {/* Cancel */}
                  {this.context.translate("_FLEET_CLOSE_BTN_")}
                </Button>
                <Button
                  type="primary"
                  //className="formSaveButton"
                  htmlType="submit"
                  loading={this.state.loading}
                  onClick={() => this.handleButtonClick("addCredit")}
                >
                  {/* css class */}
                  {/* Save */}
                  {this.context.translate("_ADD_CREDIT_")}
                </Button>
                <Button
                  type="primary"
                 // className="formSaveButton"
                  htmlType="submit"
                  loading={this.state.loading}
                  onClick={() => this.handleButtonClick("deductCredit")}
                  danger
                >
                  {/* css class */}
                  {/* Save */}
                  {this.context.translate("_DEDUCT_CREDIT_")}
                </Button>
                </Space>
              </div>
            </Form>
          </Spin>
        </div>
        
      </div>
    );
  }
}
CreditAdd.contextType = StoreContext;
export default observer(withRouter(CreditAdd));
